import { render } from "./BananaComponent.vue?vue&type=template&id=c2724b3c&scoped=true"
import script from "./BananaComponent.vue?vue&type=script&lang=js"
export * from "./BananaComponent.vue?vue&type=script&lang=js"

import "./BananaComponent.vue?vue&type=style&index=0&id=c2724b3c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2724b3c"]])

export default __exports__